'use client';
import { useEffect, useState } from 'react';
import { onIdTokenChanged } from 'firebase/auth';
import { errorCatcher } from '@/lib/error-catcher';
import { firebaseAuth } from '@/lib/firebase/firebase-client';
import { setFirebaseAdminAuthSession } from '@/server-actions/auth.action';
import { useFirebaseAuthStore } from '@/stores/auth.store';

export default function FirebaseAuthIdTokenListener() {
  const setFirebaseAuthIdToken = useFirebaseAuthStore((state) => state.setFirebaseAuthIdToken);
  const setFirebaseAuthUser = useFirebaseAuthStore((state) => state.setFirebaseAuthUser);
  const [isFirebaseAuthInitialized, setIsFirebaseAuthInitialized] = useState(false);
  useEffect(() => {
    const unsubscribe = onIdTokenChanged(firebaseAuth, async (user) => {
      console.log('Firebase auth id token listener: firebase auth id token change');
      if (user) {
        try {
          // * 當 firebase id token 有變但 user 還在，代表 firebase auth 自動 refresh id token
          // * 獲取新的 token 並更新自己存的 Next.js server side 的 session
          const newFirebaseAuthIdToken = await user.getIdToken();
          await setFirebaseAdminAuthSession({ firebaseAuthIdToken: newFirebaseAuthIdToken });
          setFirebaseAuthIdToken(newFirebaseAuthIdToken);
          setFirebaseAuthUser(user);
        } catch (error) {
          errorCatcher(error);
        }
      } else {
        // * 當 firebase id token 有變但沒有 user，代表登出
        setFirebaseAuthIdToken(null);
        setFirebaseAuthUser(null);
        // * 清除 session 的部分已由 @/lib/utils 內的 signOut() 處理，這邊就先不寫，未來有更多需求再說
      }
      setIsFirebaseAuthInitialized(true); // * Mark as initialized after processing
    });

    // * Clean up subscription
    return () => unsubscribe();
  }, [setFirebaseAuthIdToken, setFirebaseAuthUser]);
  // * Ensure the component renders children only after initialization
  if (!isFirebaseAuthInitialized) {
    return null;
  }
  return null; // * 這是一個純功能性 component 不需 render 任何內容
}
